import React, { useContext } from 'react';
import {
  IObjektVy,
  IObjektVyComp,
  IBusinessCollectionProps,
} from '../../../../../../../Types/ObjektVy';
import EDAvenyProgress from '../../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import EDListItem from '../../../../../../../BaseComponents/List/Components/EDListItem';
import EDList from '../../../../../../../BaseComponents/List/EDList';
import shortid from 'shortid';
import { FranvaroReservForQuery_db_SYSFranvaro_All } from './Queries/_QueryTypes/FranvaroReservForQuery';
import FranvaroListItem from '../FranvaroListItem/FranvaroListItem';
import { FranvaroContext } from '../../Context/FranvaroContext/FranvaroContext';

interface IProps extends IBusinessCollectionProps {}

const FranvaroReserverForViewComp: React.FC<
  React.PropsWithChildren<IProps>
> = () => {
  const franvaroContext = useContext(FranvaroContext);

  if (franvaroContext == null) {
    throw new Error('FranvaroContext saknas');
  }

  return (
    <>
      <EDList
        style={{
          width: '100%',
        }}
      >
        <>
          {franvaroContext.franvaroReservForData &&
          (franvaroContext.franvaroReservForData.length ?? 0) > 0 ? (
            franvaroContext.franvaroReservForData?.map(
              (franvaro: FranvaroReservForQuery_db_SYSFranvaro_All, index) => {
                const key = shortid.generate();
                return (
                  <FranvaroListItem
                    isAuto={franvaro.AUTOSKAPAD ?? false}
                    isReservFor
                    key={key}
                    level={franvaro.AUTOSKAPAD_LEVEL ?? 0}
                    pointer={false}
                    franvaro={franvaro}
                    index={index}
                  />
                );
              }
            )
          ) : (
            <EDListItem>
              <EDTypography>Det finns ingen frånvaro registrerad</EDTypography>
            </EDListItem>
          )}
          {franvaroContext.franvaroReservForQueryLoading && <EDAvenyProgress />}
        </>
      </EDList>
    </>
  );
};

const FranvaroReservForComp: IObjektVyComp = {
  caption: '',
  comp: (props: IProps) => <FranvaroReserverForViewComp {...props} />,
};

export const FranvaroReservForView: IObjektVy = {
  type: 'ObjektVy',
  id: 'FranvaroReserFor',
  info: {},
  def: () => FranvaroReservForComp,
};
